import * as React from 'react'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

import ExportDatesRange from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportDatesRange'
import ExportEmployeeSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportEmployeeSelector'

interface Props {
  form: ReportsForm
}

const UsedTimeoffFields = ({ form }: Props) => {
  return (
    <>
      <ExportEmployeeSelector form={form} />
      <ExportDatesRange form={form} />
    </>
  )
}

export default UsedTimeoffFields
